export default key => {
    const systemInfo = localStorage.getItem('systemInfo');
    let system = {};
    if (systemInfo && systemInfo !== '[object Object]') {
        system = JSON.parse(decodeURIComponent(decodeURIComponent(systemInfo)));
        system = {
            ...system,
            access_token: system.token,
        };
    }
    if (key) {
        return system[key];
    }
};
